export default __webpack_public_path__ + "static/media/BarbiImg.ac0edd8d.jpg";